import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../redux/reducers/index";
import { callData, callCategories, callDataOutstanding, callLandingLanguage, callAveonlineIntegration, callClientId } from "../redux/actions";
import config, { path } from "../config/enviroment";
import { ThemeProvider } from "styled-components";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import { renderRoutes } from "react-router-config";
import routes from "../routes/routes";
import Header from "./Header";
import Footer from "./Footer";
import Page from "../theme/Page";
import ShoppingCart from "../components/ShoppingCart";
import MobileNavButton from "../components/MobileNavBotton";
import { formatPhoneNumber } from "../utils/formatData";
import Inactive from "../views/Inactive";
import WhatsAppChatWidget from "./WhatsAppChatWidget";
import NotificationModal from "./NotificationModal";
import MarcaBlancaModal from "./MarcaBlancaModal";
import { shouldShowMarcaBlancaModal } from "./MarcaBlancaModal/shouldShow";
import MarcaBlancaCartLimitModal from "./MarcaBlancaCartLimitModal";
import { hideMarcaBlancaCartLimit } from "../redux/actions/marcaBlancaActions";
import { isSummaryPage } from "../redux/actions/shoppingCartActions";
import useMarcaBlancaGuard from "../hooks/useMarcaBlancaGuard";
import useMarcaBlancaHashAuth from "../hooks/useMarcaBlancaHashAuth";
import Error404 from "../views/Errors 404";
import { initializeAnalytics } from "../utils/analitycs";
import BannerFreeDelivery from "./BannerFreeDelivery";
import loadData from "../utils/loadData";
import { language } from "../utils/language";
import useBeforeUnload from "../hooks/useBeforeUnload";
import { captureCartReturnPath } from "../utils/cartReturnPath";

const history: any = createBrowserHistory();

const App = () => {
	const [redirectInactive, setRedirectInactive] = useState(false);
	const [redirectInactive404, setRedirectInactive404] = useState(false);
	const theme = useSelector((state: any) => state.theme);
	const homeState: HomeStateType = useSelector(
		(state: RootState) => state.home
	);
	const categoryState: any = useSelector((state: RootState) => state.category);
	const dispatch = useDispatch();
	const elogisticaState: any = useSelector(
		(state: RootState) => state.elogistica
	);
	const clientState: any = useSelector((state: RootState) => state.client);
	const marcaBlancaState: any = useSelector(
		(state: RootState) => state.marcaBlanca
	);

	useMarcaBlancaHashAuth();

	// Bloquea el acceso a producto/checkout si el cliente Marca Blanca no ha
	// validado, re-verificando contra el backend en cada navegación.
	useMarcaBlancaGuard(history);
	const [errorElogistica, setErrorElogistica] = useState(false);
	const [menssageError] = useState(language[homeState.default_language]["tryLater"]);
	const refData: any = useRef();
	const message = (
		<span>
			<a style={{ overflowWrap: "break-word" }} href={window.location.href}>
				{window.location.href}
			</a>{" "}
			{language[homeState.default_language]["hi"]}
		</span>
	);
	const [manage, setManage] = useState(0);

	const getManage = () => {
		return window.location.search === "?manage=1" ? 1 : 0;
	};


  const loadDataLanding = async () => {
    const queryManage = getManage();
    setManage(queryManage)
    const response = await loadData(path, queryManage)
    dispatch(callData(response, queryManage))
    if (queryManage === 1 || (response && response.success && response.data.catalogue.edataStatus ==='Permitido' && response.data.catalogue.statusCatalogue ==='activo')) {
      dispatch(callDataOutstanding(response.data.productsOutstanding))
      dispatch(callCategories(response.data.categories))
      dispatch(callAveonlineIntegration(response.data.aveonlineIntegration))
			dispatch(callClientId(response.data?.clientId))
      const storedLanguage = localStorage.getItem(`LandingLanguage${response.data.catalogue.name}`);
      if (storedLanguage) {
        dispatch(callLandingLanguage(JSON.parse(storedLanguage)));
      } else {
        const language = response.data.catalogue.default_language || "ESP";
        dispatch(callLandingLanguage(language))
        localStorage.setItem(`LandingLanguage${response.data.catalogue.name}`, JSON.stringify(language));
      }
    }
  }
  useEffect(() => {
		loadDataLanding();
	}, []);

	const handleLanguageChange = (language: string) => {
		const currentLanguage = JSON.parse(localStorage.getItem(`LandingLanguage${homeState.catalogueName}`) || '');

		if (language !== currentLanguage) {
		  dispatch(callLandingLanguage(language));
		  localStorage.setItem(`LandingLanguage${homeState.catalogueName}`, JSON.stringify(language));
		}
	};

	useEffect(() => {
		if (homeState.inactive && homeState.redirectInactive) {
			setRedirectInactive(true);
		} else if (homeState.redirectInactive && homeState.inactive404) {
			setRedirectInactive404(true);
		}
	}, [homeState.redirectInactive, homeState.inactive404]);

	useEffect(() => {
		if (
			!errorElogistica &&
			elogisticaState.LoadError &&
			homeState.epaycoDeliveryProvider
		) {
			setErrorElogistica(true);
			refData.current.open();
		}
	}, [elogisticaState.LoadError]);

	useEffect(() => {
		initializeAnalytics(homeState.analytics);
	}, [homeState.analytics]);


    const shoppingCart: ShoppingCartStateType = useSelector((state: RootState) => state.shoppingCart)
    
	const excludedRoutes = [
        /^\/vende\/[^/]+\/carrito\/[a-f0-9]{16,}$/ 
	];    
    const shouldWarn = shoppingCart.cartInfo.length > 0;
    
    useBeforeUnload(shouldWarn, excludedRoutes);

	return (
		<>
			{redirectInactive ? (
				<Inactive />
			) : redirectInactive404 ? (
				<Error404 />
			) : (
				<ThemeProvider theme={theme}>
					<Router history={history}>
						<Page
							title={homeState.catalogueName}
							favicon={homeState.image}
							loading={homeState.loading}
						>
							<Header
								color={homeState.color}
								catalogueName={homeState.image}
								categories={categoryState.listCategory}
								onLanguageChange={handleLanguageChange}
								defaultLanguage={homeState.default_language}
							/>
							{homeState.epaycoDeliveryProvider && homeState.freeDelivery && (
								<BannerFreeDelivery color={homeState.color} />
							)}
							{renderRoutes(routes)}
							{/* <Suspense fallback={'carcando'}>{renderRoutes(route.routes)}</Suspense> */}
							<Footer
								contactEmail={homeState.contactEmail}
								contactPhone={formatPhoneNumber(
									homeState.contactPhone,
									homeState.indicativoPais
								)}
								color={homeState.color}
								bottom={homeState.footerMarginBottom}
								manage={homeState.manage}
							/>
							<MobileNavButton />

							<WhatsAppChatWidget
								phoneNumber={homeState.indicativoPais + homeState.contactPhone}
								companyName={homeState.catalogueName}
								message={message}
								textReplyTime="WhatsApp"
								whatsappActive={homeState.whatsappActive}
								bottom={homeState.whatsappButtonMarginBottom}
							/>
							<ShoppingCart />
							{shouldShowMarcaBlancaModal(clientState?.id, config.marcaBlancaId) &&
								!/\/purchase(\/|$)/i.test(window.location.pathname) &&
								marcaBlancaState.hashAuthStatus !== "validating" &&
								!marcaBlancaState.validated && (
								<MarcaBlancaModal
									hashAuthResponse={marcaBlancaState.hashAuthResponse}
								/>
							)}
							<MarcaBlancaCartLimitModal
								open={marcaBlancaState.showCartLimit}
								color={homeState.color}
								title={language[homeState.default_language]["marcaBlancaCartLimitTitle"]}
								message={language[homeState.default_language]["marcaBlancaCartLimitMessage"]}
								goToCartLabel={language[homeState.default_language]["marcaBlancaCartLimitGoToCart"]}
								closeLabel={language[homeState.default_language]["close"]}
								onClose={() => dispatch(hideMarcaBlancaCartLimit())}
								onGoToCart={() => {
									dispatch(hideMarcaBlancaCartLimit());
									dispatch(isSummaryPage(false));
									history.push(
										`/vende/${homeState.catalogueUrlName}/carrito/${shoppingCart.id}`,
										{ from: captureCartReturnPath() }
									);
								}}
							/>
							{homeState.epaycoDeliveryProvider && (
								<NotificationModal refData={refData} message={menssageError} />
							)}
						</Page>
					</Router>
				</ThemeProvider>
			)}
		</>
	);
};
export default App;
